import { auth as useAuthStore } from 'src/store/auth';
import { region as useRegionStore } from 'src/store/region';

// Initialize auth from localStorage to prevent need for hard refreshes on Firebase
export default async ({} /* { app, router, Vue ... } */) => {
  const auth = useAuthStore();
  const region = useRegionStore();

  auth.initializeStore();
  region.initializeStore();
};
